import React from 'react';

export default function(props){
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <a href="https://www.ceis.com.py" className="text-dark">CEIS</a>
            <a
              className="btn btn-light"
              href="https://www.facebook.com/CEISHOHENAU"
              rel="noopener noreferrer"
              target="_blank">
              <i className="fab fa-facebook-square"></i>
            </a>
            <span>
              Tel: <a href="tel:+5950985837488">0985 837 488</a> O al <a href="https://wa.me/5950985837488" target={'_blank'}>
                WhatsApp <i className="fab fa-whatsapp"></i>
              </a>
            </span>
          </div>
          <div className="col-md-6 footer-tamay">
            Desarrollado e Implementado por
              <a
                href="http://www.tamaysistemas.com"
                rel="noopener noreferrer"
                target="_blank">
                TamaySistemas
              </a>
          </div>
        </div>
      </div>
    </footer>
  );
};



// WEBPACK FOOTER //
// ./src/components/footer.js